// export function beautifyNumber(num) {
//     if (!num || num === undefined || num === null || num === '') {
//         num = 0;
//     }

//     const negative = num < 0;


//     let fixedNum = Math.abs(num);
//     let formattedString;

//     if (fixedNum % 1 === 0) { // Check if the number is whole
//         formattedString = fixedNum.toLocaleString('en-US', { maximumFractionDigits: 0 });
//     } else {
//         formattedString = fixedNum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     }

//     let addedSpaces = 10 - formattedString.length;

//     if (addedSpaces < 0) {
//         addedSpaces = 0;
//     }
//     if (num === 0) {
//         formattedString = '0.00'
//     }
//     if (negative && (formattedString.trim() !== '0.00' && formattedString.trim() !== '0')) {
//         return `(${formattedString})`.padEnd(10, ' ');
//     } else {
//         return formattedString.padEnd(10, ' ');
//     }
// }


// export function beautifyNumber(num) {

//     if (!num || num === undefined || num === null || num === '' || num === '-') {
//         num = 0;
//     }

//     const negative = num < 0;
//     const fixedNum = Math.abs(num);

//     // Format the number with exactly two decimal places
//     let formattedString = fixedNum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     // Add spaces to ensure length of 10 characters
//     let addedSpaces = 10 - formattedString.length;
//     if (addedSpaces < 0) {
//         addedSpaces = 0;
//     }

//     if (num === 0) {
//         formattedString = '0.00';
//     }

//     if (negative && (formattedString.trim() !== '0.00' && formattedString.trim() !== '0')) {
//         return `(${formattedString})`.padEnd(10, ' ');
//     } else {
//         return formattedString.padEnd(10, ' ');
//     }
// }



//added decimals 2 by default
// export function beautifyNumber(num, decimals = 2) {
//     if (!num || num === undefined || num === null || num === '' || num === '-') {
//         num = 0;
//     }

//     const negative = num < 0;
//     const fixedNum = Math.abs(num);

//     // Format the number with dynamic decimal places
//     let formattedString = fixedNum.toLocaleString('en-US', {
//         minimumFractionDigits: decimals,
//         maximumFractionDigits: decimals
//     });

//     // Add spaces to ensure length of 10 characters
//     let addedSpaces = 10 - formattedString.length;
//     if (addedSpaces < 0) {
//         addedSpaces = 0;
//     }

//     if (num === 0) {
//         formattedString = (0).toFixed(decimals);
//     }

//     if (negative && (formattedString.trim() !== '0.00' && formattedString.trim() !== '0')) {
//         return `(${formattedString})`.padEnd(10, ' ');
//     } else {
//         return formattedString.padEnd(10, ' ');
//     }
// }

/**
 * Matches the backend RoundVatToInteger logic (GetVatValue.cs):
 * if fraction >= 0.49 → round up (ceiling), otherwise → round down (floor).
 */
export function roundVatToInteger(vatAmount) {
    if (!vatAmount && vatAmount !== 0) return 0;
    const num = Number(vatAmount);
    if (isNaN(num)) return 0;
    const fraction = num - Math.trunc(num);
    return fraction >= 0.49 ? Math.ceil(num) : Math.floor(num);
}

/**
 * Inverse of beautifyNumber for filters/sort: "1,980.00", "(1,240.00)", 1980 → number.
 * Returns null when the value cannot be parsed.
 */
export function parseBeautifiedNumber(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;

    const str = String(value).trim();
    if (!str) return null;

    const isNegative = str.includes('(');
    const cleaned = str.replace(/[(),\s]/g, '');
    if (!cleaned || cleaned === '-' || cleaned === '.' || cleaned === '-.') return null;

    const n = Number(cleaned);
    if (!Number.isFinite(n)) return null;
    return isNegative ? -Math.abs(n) : n;
}

export function beautifyNumber(num, decimals = 2, asInteger = false) {
    if (!num && num !== 0) num = 0;

    const negative = num < 0;
    const fixedNum = Math.abs(num);

    // Build the formatting options first
    const options = asInteger
        ? { maximumFractionDigits: 0 }
        : { minimumFractionDigits: decimals, maximumFractionDigits: decimals };

    let formattedString = fixedNum.toLocaleString('en-US', options);

    /* ───── integers branch ───── */
    if (asInteger) {
        // Parenthesize negative integers (except pure zero)
        if (negative && formattedString.trim() !== '0') {
            return `(${formattedString})`;
        }
        return formattedString;           // positive integer
    }

    /* ───── decimal branch ───── */
    if (num === 0) formattedString = (0).toFixed(decimals);

    // Pad to 10 chars like your original code
    const padded = formattedString.padEnd(10, ' ');

    if (negative && formattedString.trim() !== '0.00' && formattedString.trim() !== '0') {
        return `(${formattedString})`.padEnd(10, ' ');
    }
    return padded;
}
